import { Map, View, Collection, Feature, TileLayer, VectorLayer, XYZ, VectorSource, Zoom, Attribution, DragPan, DoubleClickZoom, PinchZoom, MouseWheelZoom, DragZoom, KeyboardPan, KeyboardZoom, Point, Icon, Style, Control } from '../src/ts/openlayers/ol-bridge';
import { SITEMAP_LAYER_ID, settings, attachments_overlay, view, OnMapDoubleClick, _mapLayers, get_map_layer_by_id } from './cms_view_map';
import { cmsTechGetWorkOrderQuery } from './cms_tech';
import { refetchAllData, fetchAssetsData, fetchAttachmentsData } from './cms_apis';
import { mapControl_mousePosition } from './cms_view_mapcontrols';
import { buildnum } from './buildinfo';
import { dispatch, dispatchBatch, subscribe, getState, getImmState, immState, previous_state, immutable_state, KEY_DOWNLOADED_ASSET_FLOORS, KEY_DOWNLOADED_ATTACHMENT_FLOORS, getJSBool, VALUE_CREATING_ATTACHMENT_VOID, VALUE_CREATING_ATTACHMENT_GETTING_COORD, VALUE_CREATING_ATTACHMENT_GETTING_FILE, VALUE_CREATING_ATTACHMENT_GETTING_URL, VALUE_CREATING_ATTACHMENT_SAVING_FILE, VALUE_CREATING_ATTACHMENT_API_BUSY, dispatchFloorplanVariables } from './cms_view_datastore';
import {
    KEY_DATA_ASSETS,
    KEY_DATA_ALL_ATTACHMENTS,
    KEY_DATA_WORKORDERS,
    KEY_DATA_PUSHPIN_COORDS,
    KEY_DATA_FLOOR_ATTACHMENTS,
    KEY_STATE_API_UPDATEATTACHMENT,
    KEY_STATE_API_CREATEATTACHMENT,
    KEY_STATE_API_DELETEATTACHMENT,
    KEY_STATE_ADD_WORKORDER,
    KEY_STATE_ADD_ASSET,
    KEY_STATE_ADD_FINDING,
    KEY_STATE_UI_CREATEATTACHMENT_GET_FILE,
    KEY_STATE_UI_CREATEATTACHMENT_GET_LINK,
    KEY_STATE_UI_CREATEATTACHMENT_GET_COORD,
    KEY_STATE_CREATING_ATTACHMENT,
    KEY_STATE_IS_PAGE_CURRENTLY_SITEMAP,
    KEY_STATE_SITEMAP_AVAILABLE,
    KEY_ADD_ATTACHMENT_OBJECT,
    KEY_DEBUG_ENABLED,
    KEY_ID_FLOOR,
    KEY_ID_BUILDING,
    KEY_ID_DRAWING,
    KEY_DRAWING_P1P2,
    KEY_MENU_ATTACHMENTS_CONTENT,
    KEY_MENU_ATTACHMENTS_SELECTED,
    KEY_MENU_ASSETS_CONTENT,
    KEY_MENU_ASSETS_EXPANDED,
    KEY_MENU_ASSETS_SELECTED,
    KEY_MENU_PUSHPIN_SELECTED,
    KEY_MENU_BUILDINGS_CONTENT,
    KEY_MENU_BUILDINGS_SHOW,
    KEY_MENU_WORKORDERS_CONTENT,
    KEY_MENU_WORKORDERS_SELECTED,
    KEY_MENU_WORKORDERS_EXPANDED,
    KEY_MOUSE_CURSOR
} from './cms_view_datastore';
import { didChange, didAnyChange, did_any_value_change, did_any_change, didValueChange } from './utils';

var old_imm_state = null  // awh todo: remove this and when it's needed call previous_state()

ts_temp__initializer(immState, previous_state, dispatch, dispatchBatch)  // this lets the TS code access the dispatcher and getState functions

// called when the user opts to cancel out of adding an attachment
function add_attachment_cancel() {
    // awh move to attachment_ui.ts
    dispatchBatch([[ACTION_SET_ADD_ATTACHMENT_STATE, STATE_CREATING_ATTACHMENT_VOID],
    [ACTION_UI_CREATEATTACHMENT_GET_FILE_STOP, null],
    [ACTION_UI_CREATEATTACHMENT_GET_LINK_STOP, null]]);
}

function add_attachment_save() {
    // awh move to attachment_ui.ts

    var attachment_object = getJSObject(new_imm_state, KEY_ADD_ATTACHMENT_OBJECT, {});

    if (_.has(attachment_object, "coord")) {
        if (_.has(attachment_object, "file_base64")) {
            if (_.has(attachment_object, "file_extension")) {
                if (_.has(attachment_object, "id_location")) {
                    if (_.has(attachment_object, "p1p2")) {
                        if (attachment_object.file_base64 !== "") {
                            if (attachment_object.file_extension !== "") {
                                postCreateAttachment(attachment_object.file_base64,
                                    attachment_object.file_extension,
                                    new_imm_state.get(KEY_ID_FLOOR),
                                    attachment_object.coord,
                                    attachment_object.p1p2,
                                    ts_temp__cmsInputApiGateway(),
                                    ts_temp__cmsInputToken(),
                                    ts_temp__cmsInputSegmentId());
                                dispatch(ACTION_UI_CREATEATTACHMENT_GET_FILE_STOP, null);
                                return;
                            }
                        }
                    }
                }
            }
        }
    }
    console.error('add_attachment_save - ADD_ATTACHMENT_OBJECT is not in a complete state')
    dispatch(ACTION_UI_CREATEATTACHMENT_GET_FILE_STOP, null);

}

function add_attachment_link_save() {
    ts_temp__add_attachment_link_save(immState(), dispatch);
}

function click_sitemap_link(id_building, id_floor, tilesURL, id_drawing) {
    // awh move to sitemap_ui.ts
    dispatch(ts_temp__actions.ACTION_SET_FLOOR, { "id_floor": id_floor });
    $('#menu_sitemap').hide();
}


function menu_state_id_floor() {
    return $("#menu_floorplans").data("id_location")
}

function menu_state_floor_id_drawing() {
    return $("#menu_floorplans").data("id_drawing")
}

function __map_base_layer_url() {
    var url = ""
    map.getLayers().forEach(function (layer) {
        var properties = layer.getProperties();
        if (properties.isBaseLayer) {
            var u = layer.getSource().getUrls();
            if (u) {
                url = u[0];
            }
        }
    });
    return url
}

function map_drawing_button_clicked(clickEvent) {
    var state = getState();
    var button = $(clickEvent.currentTarget);
    var clicked_id_drawing = button.data("id_drawing");
    if (state.id_drawing != clicked_id_drawing) {
        dispatchFloorplanVariables(state.id_floor, clicked_id_drawing)
    }
}

function map_state_floor() {
    var r = {
        id_location: 0,
        id_drawing: ""
    };
    try {
        let base_layer_url = __map_base_layer_url();
        // assume the url looks something like this:
        // https://portalvhdsc1clt6c22szhn........6/81082/3866477a-a3ab-4374-b82f-a85085850018/{z}/{x}/{y}.png
        base_layer_url = base_layer_url.replace("/{z}/{x}/{y}.png", "");
        let tokens = base_layer_url.split("/");
        let id_location = tokens[tokens.length - 2];
        let id_drawing = tokens[tokens.length - 1];
        r.id_location = id_location;
        r.id_drawing = id_drawing;
    } catch (err) {
        console.error(err);
    }
    return r;
}
function cookieUpdater(imm_old_state, imm_new_state) {
    // awh todo update cookies here
    if (didValueChange(imm_old_state, imm_new_state, KEY_ID_FLOOR)) {
        // set cookie  awh todo
    }
}


// observe and act upon changes in the state that affect the attachments
function attachmentViewListener(old_imm_state, new_imm_state) {
    // awh move to attachment_ui.ts



    if (didChange(previous_state(), immutable_state(), KEY_STATE_API_UPDATEATTACHMENT)) {
        var updating = getJSBool(immState(), KEY_STATE_API_UPDATEATTACHMENT);
        if (updating) {
            __lock_the_screen("Updating Photo", "Updating...");
        }
        else {
            refetchAttachmentsData();
            __unlock_the_screen();
        }
    }

    if (didChange(previous_state(), immutable_state(), KEY_STATE_API_DELETEATTACHMENT)) {
        // if deleting changed from false -> true, delete is started
        var deleting_started = getJSBool(new_imm_state, KEY_STATE_API_DELETEATTACHMENT)
        if (deleting_started) {
            __api_deleteattachment_start()
        }
        else {
            __api_deleteattachment_stop()
        }
    }

    if (didChange(previous_state(), immutable_state(), KEY_STATE_API_CREATEATTACHMENT)) {
        var in_createattachment = getJSBool(new_imm_state, KEY_STATE_API_CREATEATTACHMENT);
        if (in_createattachment) {
            __api_createattachment_start()
        } else {
            __api_createattachment_stop()
        }
    }
    if (didChange(previous_state(), immutable_state(), KEY_STATE_UI_CREATEATTACHMENT_GET_FILE)) {
        var is_visible = getJSBool(new_imm_state, KEY_STATE_UI_CREATEATTACHMENT_GET_FILE);
        if (is_visible) {
            $('#add_attachment_modal_content_image').show();
            $('#add_attachment_modal_content_link').hide();
            $('#add_attachment_modal_save_button').prop('disabled', true);
            $('#add_attachment_modal_save_button').show();
            $('#add_attachment_modal_title').html("Add Photo");
            $('#add_attachment_link_modal_save_button').prop('disabled', true);
            $('#add_attachment_link_modal_save_button').hide();
            $('#add_attachment_modal_file_picker_label').html("Choose an image file:");
            $('#add_attachment_modal_file_picker_preview').hide();
            $("#add_attachment_modal_file_picker").val("");
            $('#add_attachment_modal').modal('show');
        } else {
            $('#add_attachment_modal_save_button').prop('disabled', true);
            $('#add_attachment_modal').modal('hide');
            $('#add_attachment_modal_file_picker_preview').attr('src', "");
        }
    }
    if (didChange(previous_state(), immutable_state(), KEY_STATE_UI_CREATEATTACHMENT_GET_LINK)) {
        var is_visible = getJSBool(new_imm_state, KEY_STATE_UI_CREATEATTACHMENT_GET_LINK);
        if (is_visible) {
            $('#add_attachment_modal_content_image').hide();
            $('#add_attachment_modal_content_link').show();
            $('#add_attachment_modal_link').show();
            $('#add_attachment_modal_save_button').prop('disabled', true);
            $('#add_attachment_modal_save_button').hide();
            $('#add_attachment_link_modal_save_button').prop('disabled', true);
            $('#add_attachment_link_modal_save_button').show();
            $('#add_attachment_modal_title').html("Add Link");
            $('#add_attachment_modal').modal('show');
            $('#add_attachment_modal_link').val("");
        } else {
            $('#add_attachment_link_modal_save_button').prop('disabled', true);
            $('#add_attachment_modal').modal('hide');
            $('#add_attachment_modal_file_picker_preview').attr('src', "");
        }
    }
    if (didChange(previous_state(), immutable_state(), KEY_STATE_UI_CREATEATTACHMENT_GET_COORD)) {
        __toggle_add_attachment_mode(new_imm_state)
    }



    // check to see if we are building a new attachment
    if (didChange(previous_state(), immutable_state(), KEY_STATE_CREATING_ATTACHMENT)) {
        var creating_attachment_state_name = new_imm_state.get(KEY_STATE_CREATING_ATTACHMENT)
        // bring us in or out of the add attachment state
        if (creating_attachment_state_name === VALUE_CREATING_ATTACHMENT_VOID) {
            refetchAttachmentsData();
        }
        if (creating_attachment_state_name === VALUE_CREATING_ATTACHMENT_GETTING_COORD) {
            //            __toggle_add_attachment_mode(new_imm_state)
        }
        if (creating_attachment_state_name === VALUE_CREATING_ATTACHMENT_GETTING_FILE) {
            //            __toggle_add_attachment_mode(new_imm_state)
            //            $('#add_attachment_modal_save_button').addClass('disabled');
            //            $('#add_attachment_modal_file_picker_label').html("Choose an image file:");
            //            $("#add_attachment_modal_file_picker").val("");
            //            $('#add_attachment_modal').modal('show');
        }
    }

    if (didChange(previous_state(), immutable_state(), KEY_ADD_ATTACHMENT_OBJECT)) {

        var attachment_object = getJSObject(new_imm_state, KEY_ADD_ATTACHMENT_OBJECT, {});

        save_button_enabled = false

        var attachment_type = attachment_object.attachment_type;
        if (attachment_type === 'image') {
            if (_.has(attachment_object, "coord")) {
                if (_.has(attachment_object, "file_base64")) {
                    if (_.has(attachment_object, "file_extension")) {
                        if (_.has(attachment_object, "id_location")) {
                            if (_.has(attachment_object, "p1p2")) {
                                if (attachment_object.file_base64 !== "") {
                                    if (attachment_object.file_extension !== "") {
                                        save_button_enabled = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            if (save_button_enabled) {
                $('#add_attachment_modal_save_button').prop('disabled', false);
            } else {
                $('#add_attachment_modal_save_button').prop('disabled', true);
            }
        }
        else {

        }
    }
}  //end attachmentViewListener

// viewListener() gets called whenever the datastore is updated (hundreds of times on page load). Any internal call
// should only perform work if it has actually been impacted.
function viewListener() {
    let new_imm_state = immState();
    let js_state = new_imm_state.toJS();  // this is just a convenience format. References to this can and should be updated

    if (old_imm_state == null) //TODO this can go away
    {
        old_imm_state = new_imm_state;
    }


    attachmentViewListener(old_imm_state, new_imm_state);

    if (new_imm_state.get("fetching_assets")) {
        $('#loading_assets').show();
    }
    else {
        $('#loading_assets').hide();
    }
    if (new_imm_state.get("fetching_workorders")) {
        $('#loading_workorders').show();
    }
    else {
        $('#loading_workorders').hide();
    }
    if (new_imm_state.get("fetching_categories")) {
        $('#loading_categories').show();
    }
    else {
        $('#loading_categories').hide();
    }
    if (new_imm_state.get("fetching_floorplans")) {
        $('#loading_floorplans').show();
    }
    else {
        $('#loading_floorplans').hide();
    }
    if (didChange(previous_state(), immutable_state(), KEY_DEBUG_ENABLED)) {
        var debug_enabled = new_imm_state.get(KEY_DEBUG_ENABLED)
        console.log("in view_view, viewListener and KEY_DEBUG_ENABLED changed. it is: " + debug_enabled);
        $('#debug_alert').hide();
    }

    if (didAnyChange(previous_state(), immutable_state(), [KEY_ID_FLOOR, KEY_ID_BUILDING, KEY_ID_DRAWING, KEY_DRAWING_P1P2, KEY_DEBUG_ENABLED])) {
        console.log("in view_view, viewListener and something changed. ");
        redrawDebugAlertContent();
    }

    // 1. detect if the selected building has changed, and update
    // 2. detect if the selected floorplan has changed, and update
    // 3. redraw the menus
    // 4. redraw the map

    // if the current floor changed, check whether we need to download assets
    // and attachments for the new floor
    if (didChange(previous_state(), immutable_state(), KEY_ID_FLOOR)) {
        var id_floor = new_imm_state.get(KEY_ID_FLOOR)

        let data_assets_val = new_imm_state.get(KEY_DATA_ASSETS);
        let data_assets = data_assets_val && data_assets_val.toJS ? data_assets_val.toJS() : [];

        let downloaded_assets_val = new_imm_state.get(KEY_DOWNLOADED_ASSET_FLOORS);
        let downloaded_assets = downloaded_assets_val && downloaded_assets_val.toJS ? downloaded_assets_val.toJS() : [];
        if (!_.includes(downloaded_assets, id_floor)) {
            fetchAssetsData(id_floor)
        }

        let downloaded_attachments_val = new_imm_state.get(KEY_DOWNLOADED_ATTACHMENT_FLOORS);
        let downloaded_attachments = downloaded_attachments_val && downloaded_attachments_val.toJS ? downloaded_attachments_val.toJS() : [];
        if (!_.includes(downloaded_attachments, id_floor)) {
            fetchAttachmentsData(id_floor)
        }


        var current_zoom = map.getView().getZoom()
        if (map.getView().getZoom()) {
            if (map.getView().getZoom() > 2) {
                map.getView().setZoom(2)
            }
        }
    }

    // detect a change in the selected floorplan
    var map_floor = map_state_floor()
    if (did_any_value_change(new_imm_state, old_imm_state, [KEY_ID_FLOOR, KEY_ID_DRAWING, KEY_DRAWINGS_INFO_DATA_HASH])) {
        setFloorplanMap()
    }

    // update the menus    
    // the attachments menu is redrawn from the TS Listener
    // the buildings menu is redrawn from the TS Listener
    // the findings menu is redrawn from the TS Listener
    // the workorders menu is redrawn from the TS Listener
    // the floorplans menu is redrawn from the TS Listener
    // the spot shadow menu is redrawn from the TS Listener

    // update the map
    map_redraw_layers()

    // if the drawing changed, notify CMS Tech
    if (didChange(previous_state(), immutable_state(), KEY_ID_DRAWING)) {
        var id_drawing = immState().get(KEY_ID_DRAWING, -1)
        var id_building = immState().get(KEY_ID_BUILDING, -1)
        var id_floor = immState().get(KEY_ID_FLOOR, -1)

        let p1p2 = immState().get(KEY_DRAWING_P1P2, null)
        if (p1p2 != null) {
            p1p2 = p1p2.toJS()
            if (p1p2) {
                if (p1p2[0]) {
                    var current_drawing = {
                        data: {
                            id_drawing: immState().get(KEY_ID_DRAWING, -1),
                            id_building: immState().get(KEY_ID_BUILDING, -1),
                            id_floor: immState().get(KEY_ID_FLOOR, -1),
                            tiles_url: immState().get(KEY_TILES_URL, ""),
                            drawing_p1_xCoord: p1p2[0][0],
                        drawing_p1_yCoord: p1p2[0][1],
                        drawing_p2_xCoord: p1p2[1][0],
                        drawing_p2_yCoord: p1p2[1][1],
                    }
                }
                __postToParentIframe({
                    msgType: "current_drawing",
                    msg_type: "current_drawing",
                    data: current_drawing
                })
            }
        }
    }
    else {
        console.error("null p1/p2 encountered at drawing " + id_drawing)
    }
}

if (did_any_value_change(new_imm_state,
    old_imm_state,
    [KEY_DEBUG_ENABLED, // if debugging was enabled or disabled, redraw the debug P1P2 markers
        KEY_DRAWING_P1P2])) {// if the p1/p2 of the drawing changed, redraw the debug P1 and P2 markers
    //map_add_remove_debug_layers(new_imm_state.get(KEY_DEBUG_ENABLED), new_imm_state.get(KEY_DRAWING_P1P2).toJS());
}

if (didChange(previous_state(), immutable_state(), KEY_STATE_ADD_ASSET)) {
    __toggle_add_asset_mode(new_imm_state)
}


if (didChange(previous_state(), immutable_state(), KEY_STATE_ADD_WORKORDER)) {
    __toggle_add_workorder_mode(new_imm_state)
}

if (didChange(previous_state(), immutable_state(), KEY_MOUSE_CURSOR)) {
    document.getElementById("map").style.cursor = immState().get(KEY_MOUSE_CURSOR)
}

if (didChange(previous_state(), immutable_state(), ts_temp__keys.KEY_STATE_UI_CREATEPUSHPIN_GET_COORD)) {
    __toggle_add_pushpin_mode(new_imm_state);
}

cookieUpdater(old_imm_state, new_imm_state)
old_imm_state = new_imm_state;
}// end viewListener()

subscribe(viewListener)
subscribe(ts_temp__ui_listener);  // typescript listener implementation

function redrawDebugAlertContent() {
    var key = immState().get(KEY_DEBUG_ENABLED);
    let new_imm_state = immState();
    var debug = new_imm_state.get(KEY_DEBUG_ENABLED);
    // console.log("in redrawDebugAlertContent. Key: " + key + " debug val: " + debug);
    // if (immState().get(KEY_DEBUG_ENABLED)) {
    //     var debug_enabled = new_imm_state.get(KEY_DEBUG_ENABLED)
    //     if (debug_enabled) {
    //         var debug = $('#debug_alert');
    //         var content = $('#debug_alert_content');
    //         //debug.appendChild(document.createTextNode('Build number: ' + buildnum));
    //         var insert = "<p>Build Number: " + buildnum + "  <br/>"
    //             + "building_id: " + getImmState().get(KEY_ID_BUILDING) + "<br/>"
    //             + "floor_id: " + getImmState().get(KEY_ID_FLOOR) + "<br/>"
    //             + "drawing p1p2: " + JSON.stringify(getImmState().get(KEY_DRAWING_P1P2)) + "<br/>"
    //             + "drawing_id: " + getImmState().get(KEY_ID_DRAWING) + "<br/>"
    //             + "id_segment: " + getImmState().get(KEY_ID_SEGMENT) + "<br/>"
    //             + "id_customer: " + getImmState().get(KEY_ID_CUSTOMER) + "<br/>"
    //             + "customer name: " + getImmState().get(KEY_CUSTOMER_NAME) + "</p>"
    //         //+    "<p>token: " + cmsInputToken() + "</p>"
    //         content.html(insert);
    //         $('#debug_alert').show();
    //     }
    //     else {
    $('#debug_alert').hide();
    // }
    // }
}

// Toggles the workorder menu item for the asset category specified and shows or hides the assets on the map
// called when an asset type is clicked in the menu
// called when an select all assets is clicked in the menu
// called when an clear all assets is clicked in the menu
function toggleAssets(assetCategory, state, persist) {
    persist = (persist == true)
    menuItemAnchor = $("#id_asset__" + assetCategory)

    // toggle the menu item
    if (menuItemAnchor.parent().prop("tagName") === "LI") {
        menuItemAnchor.parent().toggleClass("selected", state);
        // console.assert(state==menuItemAnchor.parent().hasClass("selected"),
        //                "asset menu item should match the requested state") // this just a sanity check

    }
    // toggle the map layer
    map_add_asset_layer(assetCategory, state)
    if (persist) {
        cmsInputAssetLayerDisplayed(assetCategory, state)
    }

}

// menu_state_XYZ functions describe the state of the menu based on the current HTML
function menu_state_assets() {
    r = {
        menu_assets_expanded: $("#menu_assets_content").is(":Visible"),
        assets: {
            type1: { count: 0, selected: false },
            type2: { count: 0, selected: false }
        },
        menu_assets_selected: []
    }
    r.assets = {}

    $("#menu_assets_content_list a").each(function (idx, asset_a) {
        anchor = $(asset_a)
        asset_category = anchor.data("id_category")
        selected = anchor.parent("li").hasClass("selected")
        if (selected) {
            r.menu_assets_selected.push(asset_category)
        }
    })

    return r
}



function __isVisible(html_id) {
    element = $("#" + html_id)
    if (element === null) {
        console.error("could not access '" + html_id + "'")
    }
    return element.is(":Visible")
}

/**
 * this method sends a message to CMSTech (example, edit an asset or create a workorder, etc).
 * @param msg
 * @private
 */
function __postToParentIframe(msg) {
    parent.postMessage(msg, "*")
}


function __toggle_add_attachment_mode(imm_state) {
    if (getJSBool(imm_state, KEY_STATE_UI_CREATEATTACHMENT_GET_COORD)) {
        if ($("#add_attachment_mode_alert").length == 0) {
            html = ''
            html += '<div class="alert  alert-info collapse" role="alert" id="add_attachment_mode_alert">'
            html += '  <strong>Double click on the map to add an Attachment.</strong>'
            html += '  <button type="button" class="close" data-dismiss="alert" aria-label="Cancel">'
            html += '    <span aria-hidden="true">Cancel</span>'
            html += '  </button>'
            html += '</div>'
            $("#alerts_container").append(html)
            $('#add_attachment_mode_alert').on('closed.bs.alert', function () {
                dispatchBatch([
                    [ACTION_UI_CREATEATTACHMENT_GET_COORD_STOP, null],
                    [ACTION_SET_ADD_ATTACHMENT_STATE, VALUE_CREATING_ATTACHMENT_VOID]
                ])
            })
        }
        $('#add_attachment_mode_alert').show();
    }
    else {
        $('#add_attachment_mode_alert').hide();
    }

}

function __toggle_add_pushpin_mode(imm_state) {
    if (getJSBool(imm_state, ts_temp__keys.KEY_STATE_UI_CREATEPUSHPIN_GET_COORD)) {
        if ($("#add_pushpin_mode_alert").length == 0) {
            html = ''
            html += '<div class="alert  alert-info collapse" role="alert" id="add_pushpin_mode_alert">'
            html += '  <strong>Double click on the map to add Spot Shadow.</strong>'
            html += '  <button type="button" class="close" data-dismiss="alert" aria-label="Cancel">'
            html += '    <span aria-hidden="true">Cancel</span>'
            html += '  </button>'
            html += '</div>'
            $("#alerts_container").append(html)
            $('#add_pushpin_mode_alert').on('closed.bs.alert', function () {
                dispatchBatch([
                    [ts_temp__actions.ACTION_SET_PUSHPIN_GET_COORD_STOP, null],
                    [ACTION_SET_MENU_PUSHPIN_SELECTED, false]
                ])
            })
        }
        $('#add_pushpin_mode_alert').show();
    }
    else {
        $('#add_pushpin_mode_alert').hide();
    }

}

function __toggle_add_asset_mode(imm_state) {
    if (imm_state.get(KEY_STATE_ADD_ASSET)) {
        if ($("#set_asset_mode_alert").length == 0) {
            html = ''
            html += '<div class="alert  alert-info collapse" role="alert" id="set_asset_mode_alert">'
            html += '  <strong>Double click on the map to add an Asset.</strong>'
            html += '  <button type="button" class="close" data-dismiss="alert" aria-label="Cancel">'
            html += '    <span aria-hidden="true">Cancel</span>'
            html += '  </button>'
            html += '</div>'
            $("#alerts_container").append(html)
            $('#set_asset_mode_alert').on('closed.bs.alert', function () {
                dispatch(ACTION_SET_ADD_ASSET_STATE, false)
            })
        }
        $('#set_asset_mode_alert').show();
    }
    else {
        $('#set_asset_mode_alert').hide();
    }
    document.getElementById("map").style.cursor = imm_state.get(KEY_MOUSE_CURSOR)
}


function __toggle_add_workorder_mode(imm_state) {
    if (imm_state.get(KEY_STATE_ADD_WORKORDER)) {
        if ($("#set_workorder_mode_alert").length == 0) {
            html = ''
            html += '<div class="alert  alert-info collapse" role="alert" id="set_workorder_mode_alert">'
            html += '  <strong>Double click on the map to add a Work Order.</strong>'
            html += '  <button type="button" class="close" data-dismiss="alert" aria-label="Cancel">'
            html += '    <span aria-hidden="true">Cancel</span>'
            html += '  </button>'
            html += '</div>'
            $("#alerts_container").append(html)
            $('#set_workorder_mode_alert').on('closed.bs.alert', function () {
                dispatch(ACTION_SET_ADD_WORKORDER_STATE, false)
            })
        }
        $('#set_workorder_mode_alert').show();
    }
    else {
        $('#set_workorder_mode_alert').hide();
    }
    document.getElementById("map").style.cursor = imm_state.get(KEY_MOUSE_CURSOR)
}

function map_add_remove_workorder_layer(workorder_type, show) {
    mapShowWorkorders(workorder_type, show)
}

function mapShowWorkorders(woType, show) {
    console.info("mapShowWorkorders(" + woType + ")")

    //  If the map layer already exists, detsroy it. Otherwise ghost layers can accumulate
    if (_mapLayers.workorders[woType] !== undefined) {
        map.removeLayer(_mapLayers.workorders[woType])  // clear before setting
        delete _mapLayers.workorders[woType]
    }
    if (show) {
        workorders = cmsViewWorkordersOnCurrentFloor()
        workorders = workorders.filter(function (workorder) {
            return workorder.type == woType;
        });
        _mapLayers.workorders[woType] = __makeWorkordersLayer(workorders)
        map.addLayer(_mapLayers.workorders[woType])
    }
    // else do nothing. the layer is already removed.
}

function mapShowGeoJSONLayer(show_layer) {
    if (show_layer) {
        if (sitemapOverlay === null) {
            sitemapOverlay = createsitemapOverlay(map);
        }
        if (get_map_layer_by_id(map, SITEMAP_LAYER_ID)) {
            console.error("function is called twice");
            return;
        }
        _mapLayers.geoJson = build_sitemap_layer();
        map.addLayer(_mapLayers.geoJson);
        //map.addOverlay(featureOverlay);
    }
    else {
        var sitemap_layer = get_map_layer_by_id(map, SITEMAP_LAYER_ID);
        if (sitemap_layer) {
            map.removeLayer(sitemap_layer);
        }

        _mapLayers.geoJson = null;

        map.getOverlays().clear();
        //sitemapOverlay = null;
        highlightStyleCache = {};
        highlight = null;


        //console.log("zoom??" + map.getView().getZoom());
        // seems to always set the zoom back to lowest level
        // map.getView().setZoom(map.getView().getZoom() - 1);
        // sets map to the initial zoom setting
        map.getView().setZoom(settings.initialZoom);

    }


}


var __asset_workorder_data_hash = ""

// map_redraw_layers() acts just like the menu_redraw_() functions, but for the map. This function ensures that the
// assets and workorders that are displayed on the map match the assets and workorders that are marked as selected in
// the state.
function map_redraw_layers(force_reload) {
    if (force_reload === undefined) {
        force_reload = false
    }

    let state = getState()
    let imm_state = immState()

    if (did_any_change(previous_state(), immutable_state(), [KEY_DATA_ASSETS,
        KEY_DATA_ALL_ATTACHMENTS,
        KEY_DATA_WORKORDERS,
        KEY_ID_DRAWING])) {
        force_reload = true;
    }

    if (force_reload) {
        // If a reload is being forced, simply remove and destroy all asset & workorder layers from the map. They will
        // be re-created by the repaint routine.
        let asset_categories = Object.keys(_mapLayers.assets)
        _.forEach(asset_categories, function (asset_category) {
            map.removeLayer(_mapLayers.assets[asset_category])
            delete _mapLayers.assets[asset_category]
        })

        let workorder_categories = Object.keys(_mapLayers.workorders)
        _.forEach(workorder_categories, function (workorder_category) {
            map.removeLayer(_mapLayers.workorders[workorder_category])
            delete _mapLayers.workorders[workorder_category]
        })

        // remove the attachments layer
        map.removeLayer(_mapLayers.attachments)
        delete _mapLayers.attachments

        // // remove geojson layer ??
        // map.removeLayer(_mapLayers.geoJson);
        // delete _mapLayers.geoJson

    }

    {
        // update the attachments layer if necessary
        var state_says_to_show_attachments_layer = (immState().get(KEY_MENU_ATTACHMENTS_SELECTED) == true);
        var attachments_map_layer = _mapLayers.attachments;


        if (state_says_to_show_attachments_layer) {
            // if the attachments map layer does not exist, but the state says to show it, then show it.
            if (attachments_map_layer === undefined) {
                map_add_remove_attachments_layer(true)
            }
        } else {
            // if the attachments map layer exists, but the state says not to show it, then hide it.
            if (attachments_map_layer !== undefined) {
                map_add_remove_attachments_layer(false)
            }
        }
    }

    if (didChange(previous_state(), immutable_state(), KEY_DATA_PUSHPIN_COORDS)) {
        // remove pushpin layer
        map.removeLayer(_mapLayers.pushpin);
        delete _mapLayers.pushpin;
    }
    // update pushpin layer if necessary
    var state_says_pushpin_layer_selected = (immState().get(KEY_MENU_PUSHPIN_SELECTED) == true);
    var pushpin_map_layer = _mapLayers.pushpin;
    if (state_says_pushpin_layer_selected) {
        // if pushpin layer does not exist, but state says to show it, then show it
        if (pushpin_map_layer === undefined) {
            map_add_remove_pushpin_layer(true);
        }
    }
    else {
        if (pushpin_map_layer !== undefined) {
            map_add_remove_pushpin_layer(false);
        }
    }


    const menu_assets_selected = state.menu_assets_selected || [];
    let some_asset_layer_changed = !_.isEqual(Object.keys(_mapLayers.assets).sort(), menu_assets_selected.sort())
    if (some_asset_layer_changed) {
        // remove any layer that is in on the map, but not in the state
        _.forEach(Object.keys(_mapLayers.assets), function (asset_category) {
            if (!_.includes(menu_assets_selected, asset_category)) {
                map_add_remove_asset_layer(asset_category, false)
            }
        })
        // add any layer that is in the state, but not on the map
        _.forEach(menu_assets_selected, function (asset_category) {
            if (!_.includes(Object.keys(_mapLayers.assets), asset_category)) {
                map_add_remove_asset_layer(asset_category, true)
            }
        })
    }

    const menu_workorders_selected = state.menu_workorders_selected || [];
    let some_workorder_layer_changed = !_.isEqual(Object.keys(_mapLayers.workorders).sort(), menu_workorders_selected.sort())
    if (some_workorder_layer_changed) {
        // remove any layer that is in on the map, but not in the state
        _.forEach(Object.keys(_mapLayers.workorders), function (workorder_category) {
            if (!_.includes(menu_workorders_selected, workorder_category)) {
                map_add_remove_workorder_layer(workorder_category, false)
            }
        })
        // add any layer that is in the state, but not on the map
        _.forEach(menu_workorders_selected, function (workorder_category) {
            if (!_.includes(Object.keys(_mapLayers.workorders), workorder_category)) {
                map_add_remove_workorder_layer(workorder_category, true)
            }
        })
    }

    if (did_any_change(previous_state(), immutable_state(), [KEY_STATE_IS_PAGE_CURRENTLY_SITEMAP])) {
        var is_currently_sitemap = state[KEY_STATE_IS_PAGE_CURRENTLY_SITEMAP]
        var is_sitemap_available = state[KEY_STATE_SITEMAP_AVAILABLE]
        if (is_sitemap_available) {
            if (is_currently_sitemap) {
                mapShowGeoJSONLayer(true);
                $('#menu_floorplans').hide();
            }
            else {
                mapShowGeoJSONLayer(false);
                $('#menu_sitemap').show();
                $('#menu_floorplans').show();
            }
        }
    }

}


function map_add_remove_asset_layer(assetCategory, show) {
    //console.log("adding asset layer - " + assetCategory + " - " + show)

    // If the map layer already exists, detsroy it. Otherwise ghost layers can accumulate
    if (_mapLayers.assets[assetCategory] !== undefined) {
        map.removeLayer(_mapLayers.assets[assetCategory])
        delete _mapLayers.assets[assetCategory]
    }

    if (show) {
        assets = cmsViewAssetsByCategory(getState().id_floor, assetCategory)
        _mapLayers.assets[assetCategory] = mapMakeAssetsLayer(assets)
        map.addLayer(_mapLayers.assets[assetCategory])
    }
    // else do nothing. The layer has already been removed.

}

function map_add_remove_attachments_layer(show) {

    // If the map layer already exists, detsroy it. Otherwise ghost layers can accumulate
    if (_mapLayers.attachments !== undefined) {
        map.removeLayer(_mapLayers.attachments)
        delete _mapLayers.attachments
    }

    if (show) {
        // get all the attachments for the current floor
        var state = getImmState()
        var attachments = getJSObject(state, KEY_DATA_FLOOR_ATTACHMENTS, {});
        if (attachments === undefined) {
            return;
        }
        if (Object.keys(attachments).length == 0) {
            return;
        }

        drawing_p1p2 = getJSArray(state, KEY_DRAWING_P1P2, [null, null]);

        _mapLayers.attachments = __map_make_attachments_layer(attachments, drawing_p1p2[0], drawing_p1p2[1])
        map.addLayer(_mapLayers.attachments)
    }
    // else do nothing. The layer has already been removed.

}

function map_add_remove_pushpin_layer(show) {
    // if the feature already exists, destroy it.
    if (pushpin_feature.getLength() > 0) {
        pushpin_feature.removeAt(0);
    }
    // If the map layer already exists, destroy it so ghost layers don't accumulate
    if (_mapLayers.pushpin !== undefined) {
        map.removeLayer(_mapLayers.pushpin);
        delete _mapLayers.pushpin;
    }

    if (show) {
        // get the pushpin for the current building
        var state = getImmState()
        var pushpin = getJSObject(state, KEY_DATA_PUSHPIN_COORDS, {});
        if (pushpin === undefined) {
            return;
        }
        if (Object.keys(pushpin).length == 0) {
            return;
        }

        var icon = "../target_op.png";
        var scale = get_scale();
        // if (map_zoom > 2) {
        //     icon = "https://portalvhdsc1clt6c22szhn.blob.core.windows.net/cmsview/images/target_6_op.png";
        // }
        _mapLayers.pushpin = __map_make_pushpin_layer(pushpin, scale, icon)
        map.addLayer(_mapLayers.pushpin);
    }
}

let asset_categories = Object.keys(_mapLayers.assets);

function map_add_remove_debug_layers(show) {

    var building_p1p2 = getState().building_p1p2;
    var building_p1 = building_p1p2[0];
    var building_p2 = building_p1p2[1];
    let workorder_categories = Object.keys(_mapLayers.workorders);

    p1 = getState().drawing_p1p2[0]
    p2 = getState().drawing_p1p2[1]
    // If the map layer already exists, detsroy it. Otherwise ghost layers can accumulate
    if (_mapLayers.debug !== undefined) {
        map.removeLayer(_mapLayers.debug)
        delete _mapLayers.debug
    }

    if (show) {
        if (p1[0] == null) {
            //            console.log("p1/p2 are null, nothing to display")
        }
        else {
            _mapLayers.debug = __map_make_p1p2_debug_layer(p1, p2, building_p1, building_p2)
            map.addLayer(_mapLayers.debug)
        }
    }
    // else do nothing. The layer has already been removed.

}


class mapControl_toggleMenu extends Control {
    constructor(options) {
        options = options || {};
        const button = document.createElement('button');
        const span = document.createElement('span');
        span.setAttribute("class", 'glyphicon glyphicon-menu-hamburger');
        button.appendChild(span);
        const onClick = function (e) {
            $("#wrapper").toggleClass("toggled");
        };
        const onTouchStart = function (e) {
            console.log("A Touchstart!!");
            onClick(e);
        };
        button.addEventListener('click', onClick, false);
        button.addEventListener('touchstart', onTouchStart, false);

        const element = document.createElement('div');
        element.className = ' ol-unselectable ol-control a-control';
        element.appendChild(button);

        options.element = element;
        super(options);
        if (options.target) {
            this.setTarget(options.target);
        }
    }
}

class build_map_control_0 extends Control {
    constructor(options) {
        options = options || {};
        const button = document.createElement('button');
        button.setAttribute("id", 'map_0_button');
        button.setAttribute("style", 'width: auto; min-width: 0;  margin: 1px; padding: 2px;');

        const span = document.createElement('span');
        span.setAttribute("id", 'map_0_button_span');
        span.style.visibility = 'hidden';
        span.textContent = "newtext";
        button.appendChild(span);

        button.addEventListener('click', map_drawing_button_clicked, false);

        const element = document.createElement('div');
        element.className = ' ol-unselectable ol-control map_button_0';
        element.appendChild(button);

        options.element = element;
        super(options);
        if (options.target) {
            this.setTarget(options.target);
        }
    }
}
class build_map_control_1 extends Control {
    constructor(options) {
        options = options || {};
        const button = document.createElement('button');
        button.setAttribute("id", 'map_1_button');
        button.setAttribute("style", 'width: auto; min-width: 0;  margin: 1px; padding: 2px;');

        const span = document.createElement('span');
        span.setAttribute("id", 'map_1_button_span');
        span.style.visibility = 'hidden';
        span.textContent = "newtext";
        button.appendChild(span);

        button.addEventListener('click', map_drawing_button_clicked, false);

        const element = document.createElement('div');
        element.className = ' ol-unselectable ol-control map_button_1';
        element.appendChild(button);

        options.element = element;
        super(options);
        if (options.target) {
            this.setTarget(options.target);
        }
    }
}
class build_map_control_2 extends Control {
    constructor(options) {
        options = options || {};
        const button = document.createElement('button');
        button.setAttribute("id", 'map_2_button');
        button.setAttribute("style", 'width: auto; min-width: 0;  margin: 1px; padding: 2px;');

        const span = document.createElement('span');
        span.setAttribute("id", 'map_2_button_span');
        span.style.visibility = 'hidden';
        span.textContent = "newtext";
        button.appendChild(span);

        button.addEventListener('click', map_drawing_button_clicked, false);

        const element = document.createElement('div');
        element.className = ' ol-unselectable ol-control map_button_2';
        element.appendChild(button);

        options.element = element;
        super(options);
        if (options.target) {
            this.setTarget(options.target);
        }
    }
}
class build_map_control_3 extends Control {
    constructor(options) {
        options = options || {};
        const button = document.createElement('button');
        button.setAttribute("id", 'map_3_button');
        button.setAttribute("style", 'width: auto; min-width: 0;  margin: 1px; padding: 2px;');

        const span = document.createElement('span');
        span.setAttribute("id", 'map_3_button_span');
        span.style.visibility = 'hidden';
        span.textContent = "newtext";
        button.appendChild(span);

        button.addEventListener('click', map_drawing_button_clicked, false);

        const element = document.createElement('div');
        element.className = ' ol-unselectable ol-control map_button_3';
        element.appendChild(button);

        options.element = element;
        super(options);
        if (options.target) {
            this.setTarget(options.target);
        }
    }
}
class build_map_control_4 extends Control {
    constructor(options) {
        options = options || {};
        const button = document.createElement('button');
        button.setAttribute("id", 'map_4_button');
        button.setAttribute("style", 'width: auto; min-width: 0;  margin: 1px; padding: 2px;');

        const span = document.createElement('span');
        span.setAttribute("id", 'map_4_button_span');
        span.style.visibility = 'hidden';
        span.textContent = "newtext";
        button.appendChild(span);

        button.addEventListener('click', map_drawing_button_clicked, false);

        const element = document.createElement('div');
        element.className = ' ol-unselectable ol-control map_button_4';
        element.appendChild(button);

        options.element = element;
        super(options);
        if (options.target) {
            this.setTarget(options.target);
        }
    }
}
class build_map_control_5 extends Control {
    constructor(options) {
        options = options || {};
        const button = document.createElement('button');
        button.setAttribute("id", 'map_5_button');
        button.setAttribute("style", 'width: auto; min-width: 0;  margin: 1px; padding: 2px;');

        const span = document.createElement('span');
        span.setAttribute("id", 'map_5_button_span');
        span.style.visibility = 'hidden';
        span.textContent = "newtext";
        button.appendChild(span);

        button.addEventListener('click', map_drawing_button_clicked, false);

        const element = document.createElement('div');
        element.className = ' ol-unselectable ol-control map_button_5';
        element.appendChild(button);

        options.element = element;
        super(options);
        if (options.target) {
            this.setTarget(options.target);
        }
    }
}
class build_map_control_6 extends Control {
    constructor(options) {
        options = options || {};
        const button = document.createElement('button');
        button.setAttribute("id", 'map_6_button');
        button.setAttribute("style", 'width: auto; min-width: 0;  margin: 1px; padding: 2px;');

        const span = document.createElement('span');
        span.setAttribute("id", 'map_6_button_span');
        span.style.visibility = 'hidden';
        span.textContent = "newtext";
        button.appendChild(span);

        button.addEventListener('click', map_drawing_button_clicked, false);

        const element = document.createElement('div');
        element.className = ' ol-unselectable ol-control map_button_6';
        element.appendChild(button);

        options.element = element;
        super(options);
        if (options.target) {
            this.setTarget(options.target);
        }
    }
}
class build_map_control_7 extends Control {
    constructor(options) {
        options = options || {};
        const button = document.createElement('button');
        button.setAttribute("id", 'map_7_button');
        button.setAttribute("style", 'width: auto; min-width: 0;  margin: 1px; padding: 2px;');

        const span = document.createElement('span');
        span.setAttribute("id", 'map_7_button_span');
        span.style.visibility = 'hidden';
        span.textContent = "newtext";
        button.appendChild(span);

        button.addEventListener('click', map_drawing_button_clicked, false);

        const element = document.createElement('div');
        element.className = ' ol-unselectable ol-control map_button_7';
        element.appendChild(button);

        options.element = element;
        super(options);
        if (options.target) {
            this.setTarget(options.target);
        }
    }
}
class build_map_control_8 extends Control {
    constructor(options) {
        options = options || {};
        const button = document.createElement('button');
        button.setAttribute("id", 'map_8_button');
        button.setAttribute("style", 'width: auto; min-width: 0;  margin: 1px; padding: 2px;');

        const span = document.createElement('span');
        span.setAttribute("id", 'map_8_button_span');
        span.style.visibility = 'hidden';
        span.textContent = "newtext";
        button.appendChild(span);

        button.addEventListener('click', map_drawing_button_clicked, false);

        const element = document.createElement('div');
        element.className = ' ol-unselectable ol-control map_button_8';
        element.appendChild(button);

        options.element = element;
        super(options);
        if (options.target) {
            this.setTarget(options.target);
        }
    }
}
class build_map_control_9 extends Control {
    constructor(options) {
        options = options || {};
        const button = document.createElement('button');
        button.setAttribute("id", 'map_9_button');
        button.setAttribute("style", 'width: auto; min-width: 0;  margin: 1px; padding: 2px;');

        const span = document.createElement('span');
        span.setAttribute("id", 'map_9_button_span');
        span.style.visibility = 'hidden';
        span.textContent = "newtext";
        button.appendChild(span);

        button.addEventListener('click', map_drawing_button_clicked, false);

        const element = document.createElement('div');
        element.className = ' ol-unselectable ol-control map_button_9';
        element.appendChild(button);

        options.element = element;
        super(options);
        if (options.target) {
            this.setTarget(options.target);
        }
    }
}


function map_redraw_drawings_buttons()  // this will force a redraw of the buttons on the map
{
    ts_temp__map_redraw_drawings_buttons(immState());
}

// setFloorplanMap points the floorplan as the basemap of the layers
function setFloorplanMap() {  // this call is not cheap and redraws the screen. only call it if necessary.

    var id_floor = getState().id_floor
    var tile_url = immState().get(KEY_TILES_URL);
    if (!tile_url) {
        console.error('tile URL is missing')
        return;
    }
    map.removeLayer(floorplan_layer)
    floorplan_layer = new TileLayer({
        isBaseLayer: true,
        source: new XYZ({
            url: tile_url,
            wrapX: false,
            noWrap: true,
            tileSize: settings.tileSize,
            //       crossOrigin: true,
            projection: settings.projection,
            id_location: id_floor
        })
    });

    map.getLayers().insertAt(0, floorplan_layer)  // insert the floorplan map at the lowest layer

    // clear out all selected rows, and persist the change
    map_redraw_layers(true)

}

var tile_url = immState(getState()).get(KEY_TILES_URL);
if (!tile_url) {
    tile_url = "";
}

var floorplan_layer = new TileLayer({
    isBaseLayer: true,
    source: new XYZ({
        url: tile_url,
        wrapX: false,
        noWrap: true,
        tileSize: settings.tileSize,
        //       crossOrigin: true,
        projection: settings.projection,
    })
});



function createFeature(x, y) {
    if (
        (x === undefined) ||
        (x === null) ||
        (isNaN(x)) ||
        (y === undefined) ||
        (y === null) ||
        (isNaN(y))
    ) { // passing in a point instead of an array of numbers has caused more pain than you will ever know.
        console.error("NON-Number passed into createfeature() THIS SHOULD NEVER HAPPEN. FIX THIS UPSTREAM!!")
    }

    pt = new Point([x, y], "XY")
    feature = new Feature({ geometry: pt })
    return feature
}


function mapCreateAssetFeature(asset, p0) {

    iconImg = new Icon(({
        anchor: [.5, .5],
        anchorXUnits: 'fraction',
        anchorYUnits: 'fraction',
        src: asset.icon
    }))

    iconStyle = new Style(
        {
            image: iconImg
        }
    )

    var id_asset = asset.idAsset
    var coords = asset.adj_coords
    if (coords == null) {
        coords = p0
    }

    feature = createFeature(coords[0], coords[1])
    feature.setId(id_asset)  // the idAsset is assumed to be stable and unique
    feature.setStyle(iconStyle)
    temp = asset
    temp["feature"] = "asset"
    feature.data = temp
    feature.raw = getRawAsset(id_asset) //  asset.raw

    return feature
}




/*
 * create an openlayers feature for an attachment
 */
function map_create_attachment_feature(id_attachment, attachment_url, icon_url, adj_coords, is_3D_link, is_video_link) {

    icon_img = new Icon(({
        anchor: [.5, .5],
        anchorXUnits: 'fraction',
        anchorYUnits: 'fraction',
        src: icon_url
    }))

    icon_style = new Style(
        {
            image: icon_img
        }
    )

    feature = createFeature(adj_coords[0], adj_coords[1])
    feature.setId(id_attachment)  // the idAsset is assumed to be stable and unique
    feature.setStyle(icon_style)

    var data = {};
    data.feature = "attachment";
    data.url = attachment_url;
    data.id_attachment = id_attachment;
    data.reposition_icon = icon_url;
    data.coords = adj_coords;
    data.note = "";
    data.is_3D_link = is_3D_link;
    data.is_video_link = is_video_link;
    feature.data = data;
    return feature
}

/*
 * create an openlayers feature for a pushpin
 */
function map_create_pushpin_feature(coords, scale, icon) {

    icon_img = new Icon(({
        anchor: [.5, .5],
        anchorXUnits: 'fraction',
        anchorYUnits: 'fraction',
        src: icon,
        scale: scale
    }))

    icon_style = new Style(
        {
            image: icon_img
        }
    )

    feature = createFeature(coords[0], coords[1])
    feature.setStyle(icon_style)

    var data = {};
    data.feature = "pushpin";
    data.reposition_icon = icon;
    data.coords = coords;
    data.note = "";
    feature.data = data;
    return feature
}

// icon is optional. id_workorder_asset is optional
function __createWorkorderFeature(workorder, p0, coords, id_workorder_asset) {
    var seconds_until_due = workorder.seconds_until_due;
    var icon = workorder.icon
    if (seconds_until_due < 0) {
        icon = workorder.icon_red;
    }
    else if (seconds_until_due < 60 * 60 * 24 * 7) {  // less than seven calendar days until due
        icon = workorder.icon_yellow;
    }

    iconImg = new Icon(({
        anchor: [.5, .5],
        anchorXUnits: 'fraction',
        anchorYUnits: 'fraction', src: icon
    }))

    iconStyle = new Style(
        {
            image: iconImg
        }
    )

    //var coords = workorder.adj_coords
    if (!coords) {
        console.error("workorder is missing coordinates: " + workorder.id)
        coords = p0
    }

    feature = createFeature(coords[0], coords[1])
    var id_workorder;
    feature.setStyle(iconStyle)
    
    
    if (workorder.is_multi_asset){
        var temp={}
        temp["feature"] = "multi-asset-workorder"
        temp["adj_coords"] = coords
        temp["coords"] = coords
        temp["has_coords"] = true
        temp["id_workorder_asset"] = id_workorder_asset;
        temp["id_workorder"] = workorder.id;
        for(var i =0; i < workorder.asset_info.length; i++){
            var temp_id_workorder_asset = workorder.asset_info[i].id_workorder_asset;
            if(id_workorder_asset === temp_id_workorder_asset){
                var id_asset = workorder.asset_info[i].id_asset;
                temp["id_asset"] = id_asset;
                break;
            }
        }
        // temp["id_asset"] =
        //id_workorder = id_workorder_asset;
        feature.setId(id_workorder_asset)
        feature.data = temp
    }
    else{
        var temp = workorder
        id_workorder = workorder.id // the id_workorder is assumed to be stable and unique
        feature.setId(id_workorder)
        temp["feature"] = "workorder"
        feature.data = temp
    }
    
    feature.raw = getRawWorkorder(workorder.id)
    return feature
}



var map = new Map({
    controls: [
        new Zoom(),
        new Attribution({ collapsible: false }),
        // Add other default controls as needed
        mapControl_mousePosition,
        new mapControl_toggleMenu(),
        new build_map_control_0(),
        new build_map_control_1(),
        new build_map_control_2(),
        new build_map_control_3(),
        new build_map_control_4(),
        new build_map_control_5(),
        new build_map_control_6(),
        new build_map_control_7(),
        new build_map_control_8(),
        new build_map_control_9()
    ],
    layers: [floorplan_layer],
    interactions: [
        new DragPan(),
        new DoubleClickZoom({
            condition: function () {
                var state = immState();
                var is_create_mode = state.get(KEY_STATE_ADD_WORKORDER) == true ||
                    state.get(KEY_STATE_ADD_ASSET) == true ||
                    state.get(KEY_STATE_ADD_FINDING) == true ||
                    getJSBool(state, KEY_STATE_UI_CREATEATTACHMENT_GET_COORD);
                return !is_create_mode;
            }
        }),
        new PinchZoom(),
        new MouseWheelZoom(),
        new DragZoom(),
        new KeyboardPan(),
        new KeyboardZoom(),
        // Disable rotation interactions as before
        // (altShiftDragRotate and pinchRotate are not added)
    ],
    overlays: [attachments_overlay],
    target: 'map',
    view: view,
    renderer: "canvas",
    ol3Logo: false,
    projection: settings.projection,
    extent: [0, 0, 16000, 16000]//settings.projection.getExtent()
});



function __makeWorkordersLayer(workorders) {
    var workorder_features = new Collection();
    var p0 = getImmState().get(KEY_DRAWING_P0).toJS()
    workorders.forEach(function (workorder) {
        if (workorder.is_multi_asset){
            for (var i = 0; i<workorder.asset_info.length; i++){
                var feat = __createWorkorderFeature(workorder, p0, workorder.asset_info[i].coord, workorder.asset_info[i].id_workorder_asset)
                workorder_features.push(feat)
            }
            
        }
        else{
            var feat = __createWorkorderFeature(workorder, p0, workorder.adj_coords, null)
            workorder_features.push(feat)
        }
    })

    workorder_layer = new VectorLayer({

        source: new VectorSource({
            features: workorder_features,
            wrapX: false,
            noWrap: true,

            projection: settings.projection,
            //     extent: settings.extent
            minResolution: settings.minResolution,
            maxResolution: settings.maxResolution,
        })
    });
    return workorder_layer
}

/***
 *  map_redraw_layers() -> map_add_remove_asset_layer()-> mapMakeAssetsLayer()
*/
function mapMakeAssetsLayer(assets) {
    asset_features = new Collection();
    p0 = getImmState().get(KEY_DRAWING_P0).toJS()

    _.forEach(assets, function (asset) {
        var feat = mapCreateAssetFeature(asset, p0)
        asset_features.push(feat)
    })

    asset_layer = new VectorLayer({

        source: new VectorSource({
            features: asset_features,
            wrapX: false,
            noWrap: true,

            projection: settings.projection,
            //     extent: settings.extent
            minResolution: settings.minResolution,
            maxResolution: settings.maxResolution,
        })
    });
    return asset_layer
}


/***
 *  map_redraw_layers() -> map_add_remove_attachments_layer()-> mapMakeAttachmentsLayer()
 *  it is assumed that the attachmets have been filtered for this floor
 * attachments - 
 * {
 *   id_attachment : {
 *      id_floor,
 *      id_attachment,
 *      url,
 *      raw_coords,
 *      raw_geo_ref,
 *      raw
 *    }
 * }
 */

function __map_make_attachments_layer(attachments, drawing_p1, drawing_p2) {
    attachment_features = new Collection();

    _.forEach(attachments, function (attachment) {
        var id_attachment = attachment.id
        var raw_coords = attachment.raw_coords;
        var raw_p1 = attachment.raw_geo_ref[0];
        var raw_p2 = attachment.raw_geo_ref[1];

        adj_coords = geometry__js_translate(raw_coords[0],
            raw_coords[1],
            raw_p1[0],
            raw_p1[1],
            raw_p2[0],
            raw_p2[1],
            drawing_p1[0],
            drawing_p1[1],
            drawing_p2[0],
            drawing_p2[1])
        attachment_url = attachment.url
        icon_url = attachment.icon; //"https://portalvhdsc1clt6c22szhn.blob.core.windows.net/cmsview/icons/48/camera.png"

        var feature = map_create_attachment_feature(id_attachment, attachment_url, icon_url, adj_coords, attachment.is_3D_link, attachment.is_video_link)

        //  var feat = mapCreateAssetFeature(asset, p0)
        attachment_features.push(feature)
    })

    attachment_layer = new VectorLayer({

        source: new VectorSource({
            features: attachment_features,
            wrapX: false,
            noWrap: true,

            projection: settings.projection,
            //     extent: settings.extent
            minResolution: settings.minResolution,
            maxResolution: settings.maxResolution,
        })
    });
    return attachment_layer
}

var pushpin_feature = new Collection();
function __map_make_pushpin_layer(coords, scale, icon) {
    var feature = map_create_pushpin_feature(coords, scale, icon);
    pushpin_feature.push(feature);
    var pushpin_layer = new VectorLayer({
        source: new VectorSource({
            features: pushpin_feature,
            wrapX: false,
            noWrap: true,

            projection: settings.projection,
            //     extent: settings.extent
            minResolution: settings.minResolution,
            maxResolution: settings.maxResolution,
        })
    });
    return pushpin_layer;
}

function __map_make_p1p2_debug_layer(p1, p2, building_p1, building_p2) {
    make_feature = function (icon, x, y) {
        feature = createFeature(x, y)
        iconStyle = new Style({
            image: new Icon(({
                anchor: [.5, .5],
                anchorXUnits: 'fraction',
                anchorYUnits: 'fraction',
                src: icon
            }))
        })
        feature.setStyle(iconStyle)
        return feature
    }

    p1p2_features = new Collection();
    p1p2_features.push(make_feature("../b1.png", p1[0], p1[1]))
    p1p2_features.push(make_feature("../b2.png", p2[0], p2[1]))
    p1p2_features.push(make_feature("../b1.png", building_p1[0], building_p1[1]))
    p1p2_features.push(make_feature("../b2.png", building_p2[0], building_p2[1]))
    p1p2_layer = new VectorLayer({

        source: new VectorSource({
            features: p1p2_features,
            wrapX: false,
            noWrap: true,

            projection: settings.projection,
            //     extent: settings.extent
            minResolution: settings.minResolution,
            maxResolution: settings.maxResolution,
        })
    });
    return p1p2_layer
}



$("#menu_floorplan_header").click(function () {
    expanding = !($("#menu_floorplans_content").is(":Visible"))
    dispatchUiVariable("menu_floorplans_expanded", expanding)
});



function toggle_pushpin_layer() {
    //ts_temp__toggle_pushpin_layer(dispatch);
    enabled = true;
    anchor = $("#pushpin_menu_select")
    li = anchor.parents("li")         // the parent of the anchor is a span, the parent of the span is an li. Hence we use jquery parents(), not parent()
    selected_in_ui = li.hasClass("selected")
    enabled = !selected_in_ui;
    dispatch(ACTION_SET_MENU_PUSHPIN_SELECTED, enabled);
    if (enabled) {
        dispatch(ts_temp__actions.ACTION_SET_PUSHPIN_GET_COORD_START, null);
    }
    else {
        dispatch(ts_temp__actions.ACTION_REMOVE_PUSHPIN_COORD, null);
    }

}




///////////////////////////
// function called when a file is added to the upload field

var handleFileSelect = function (evt) {
    var files = evt.target.files;
    var file = files[0];
    var file_size = file.size;
    console.error(file_size);
    var filename = file.name
    var file_extension = filename
    var file_b64 = ""
    var max_file_size = 3.5 * 1000 * 1000 // 3.5 MB file max

    if (file_size > max_file_size) {
        // alert the user and cancel
        //        __lock_the_screen("The selected file is too large. Choose a smaller file.", "");
        //evt.target.files=null;
        __alert_the_user("Attachemnt too large", "The selected file is large and may not upload correctly")

        $('#add_attachment_modal_save_button').prop('disabled', true);  // disable the save button
        $('#add_attachment_modal_file_picker_label').html("Select a file");
        return;
    }

    file_extension = filename.split(/[.]+/).pop();


    var new_attachment_object = getJSObjectOrNull(getImmState(), KEY_ADD_ATTACHMENT_OBJECT);
    // awh todo: handle a null or empty object here


    $('#add_attachment_modal_file_picker_label').html("File: " + filename);
    if (files && file) {
        var reader = new FileReader();

        reader.onload = function (readerEvt) {
            var binaryString = readerEvt.target.result;
            var file_b64 = btoa(binaryString)

            new_attachment_object.file_base64 = file_b64
            new_attachment_object.file_extension = file_extension
            dispatch(ACTION_SET_ADD_ATTACHMENT_OBJECT, new_attachment_object);
        };
        reader.readAsBinaryString(file);

        var reader2 = new FileReader();
        reader2.onload = function (readerEvt) {
            $('#add_attachment_modal_file_picker_preview').show();
            var result = readerEvt.target.result;
            $('#add_attachment_modal_file_picker_preview').attr('src', result);
        }
        reader2.readAsDataURL(file);
    }
};


$('#add_attachment_modal_file_picker').change(handleFileSelect);


///////////////////////////
// function called when a link is added to the upload field to add link attachment

//var handleLinkSelect = function (evt) {
//    console.log("handleLinkSelect");
//    var url = $('#add_attachment_modal_link').val();
//};

$('#add_attachment_modal_link').bind('input', function (e) {
    console.log("does this work????");
    ts_temp__add_attachment_link_keydown(e, getImmState(), dispatch);
});

$('#add_attachment_modal_link').keydown(function (e) {
    if (e.which == 13) {
        e.preventDefault();
    }
    ts_temp__add_attachment_link_keydown(e, getImmState(), dispatch);
})

function openLinkNewWindow() {
    ui_attachments__open_360_link();
}


function on_pointer_move(evt) {
    if (evt.dragging) {
        return;
    }

    if (get_map_layer_by_id(map, SITEMAP_LAYER_ID)) {
        var pixel = map.getEventPixel(evt.originalEvent);
        hilight_building(pixel, map);
    }

    if (is_debug_enabled(immState())) {
        var pixel = map.getEventPixel(evt.originalEvent);
        log_map_feature_info(pixel);
        // console.log(view.getZoom());
    }
}

var scale = .25;
var map_zoom = -1;
map.on('moveend', function (moveend_event) {

    var state = immState();
    if (state.get(KEY_DATA_PUSHPIN_COORDS) === undefined) {
        return;
    }
    if (!state.get(KEY_DATA_PUSHPIN_COORDS)) {
        return;
    }
    var target = state.get(KEY_DATA_PUSHPIN_COORDS).toJS();
    if (state.get(KEY_MENU_PUSHPIN_SELECTED) && target.length > 0) {
        var new_map_zoom = map.getView().getZoom();
        if (new_map_zoom != map_zoom) {
            map_zoom = new_map_zoom;
        }
        redraw_target();
    }

});

function get_scale() {
    if (map_zoom == -1) {
        map_zoom = map.getView().getZoom();
    }

    if (map_zoom == 6) {
        scale = .99
    }
    else if (map_zoom == 5) {
        scale = .85;
    }
    else if (map_zoom == 4) {
        scale = .65;
    }
    else if (map_zoom == 3) {
        scale = .45;
    }
    else if (map_zoom == 2) {
        scale = .55;
    }
    else if (map_zoom == 1) {
        scale = .35;
    }
    else if (map_zoom == 0) {
        scale = .15;
    }
    return scale;
}

function redraw_target() {
    var state = immState();
    var target = state.get(KEY_DATA_PUSHPIN_COORDS).toJS();
    if (target.length > 0) {
        var x = target[0];
        var y = target[1];
        if (pushpin_feature.getLength() > 0) {
            map_add_remove_pushpin_layer(false);
        }
        map_add_remove_pushpin_layer(true);
    }

}

map.on('pointermove', on_pointer_move);

map.on("dblclick", OnMapDoubleClick);

map.on("click", function (e) {
    var state = immState();
    if (state.get(KEY_STATE_ADD_ASSET) == true) {
        return;  // We are in an add feature state. Do nothing on single click and add a feature on double click.
    }
    if (state.get(KEY_STATE_ADD_WORKORDER) == true) {
        return;  // We are in an add feature state. Do nothing on single click and add a feature on double click.
    }
    if (state.get(KEY_STATE_ADD_FINDING) == true) {
        return;  // We are in an add feature state. Do nothing on single click and add a feature on double click.
    }
    var current = getJSBool(getImmState(), KEY_STATE_IS_PAGE_CURRENTLY_SITEMAP);
    if (current) {
        openUrl(e.pixel, map);
    }
    var feature = map.forEachFeatureAtPixel(e.pixel, function (feature, layer) {
        if (feature.values_.data !== undefined) {
            return feature
        }
    })

    if (!feature) {
        return;  // no feature was found
    }

    // All featured that can be opened up and edited contain a data field.
    if (feature.values_.data) {
        var data = feature.values_.data;
        var feature_type = feature.values_.feature;
        if (feature_type === undefined) {
            console.error("the map feature.values_.feature field is missing the required feature field")
        }

        if (feature_type === "asset") {
            var id_asset = data.id_asset;
            var raw_asset = get_raw_asset(state, id_asset);
            parent.postMessage(raw_asset, '*');
            if (is_debug_enabled(state)) {
                jsonLog(raw_asset);
            }
            return;
        }

        if (feature_type === "finding") {
            ts_temp__map_area_on_click(e);
            return;

        }
        if (feature_type === "attachment") {
            var coordinate = e.coordinate;
            var id_attachment = data.id_attachment
            var drawing_p1p2 = state.get(KEY_DRAWING_P1P2);
            ui_attachments__attachment_clicked(state, coordinate, data, data.reposition_icon, dispatch);
            __temp_update_attachment = {};
            __temp_update_attachment.url = data.url;
            __temp_update_attachment.original_coords = data.coords;
            return;
        }

        if (feature_type === "workorder") {
            // open the edit form for the work order
            var raw = get_raw_workorder(state, data.id);
            parent.postMessage(raw, '*');
            if (getState().debug_enabled) {
                jsonLog(raw);
            }
            return;
        }

        if (feature_type === "multi-asset-workorder"){
            //var raw = get_raw_workorder_for_multi_asset_workorder(state, )
            var real_raw = get_raw_workorder(state, data.id_workorder);
            var raw = {}
            raw['id_asset'] = data.id_asset;
            raw['id_workorder_asset'] = data.id_workorder_asset;
            raw['id_workorder'] = data.id_workorder;
            raw['raw'] = real_raw;
            console.log(raw)
            parent.postMessage(raw, '*');
            if (getState().debug_enabled) {
                jsonLog(raw);
            }
            return;
        }
        console.error("the selected map feature is not an asset or a work order")
        return;
    }
    else {
        console.error("feature doesn't have a raw CMS data")
    }
})

function cmsViewReloadAll() {
    cmsTechGetWorkOrderQuery();
    refetchAllData() // a re-fetch the data from the API to update the state and force the UI to be redrawn.
}

var __temp_update_attachment = null;

function __clicked_reposition_attachment_reset() {

    return;
}

function __clicked_reposition_attachment_update() {
    if (__temp_update_attachment === null) {
        // bail
        return
    }
    var data = __temp_update_attachment;
    var attachment_url = data.url;
    var id_attachment = data.id_attachment;
    var id_floor = data.id_floor;
    var coords = data.coords;
    var geo_reference = data.geo_reference;
    var api_gateway = ts_temp__cmsInputApiGateway();
    var api_token = ts_temp__cmsInputToken();
    var api_segment_id = ts_temp__cmsInputSegmentId();
    post_updateattachment(attachment_url, id_attachment, id_floor, coords, geo_reference, api_gateway, api_token, api_segment_id);
}

function __feature_location_updated(data) {
    var feature_type = data.feature_type
    if (feature_type === "attachment") {
        __temp_update_attachment.id_attachment = data.id;
        __temp_update_attachment.id_floor = data.idLocation;
        __temp_update_attachment.coords = data.coords;
        __temp_update_attachment.geo_reference = [data.p1Coord, data.p2Coord];
        return;
    }
}


function __event_listener(event) {  // AWH TODO - move all of these to typescript. the function exists in event_listener.ts and is already being called.
    if (typeof (event.data) === typeof ("")) {
        // if the data element is not an object, bail.
        return;
    }
    //console.log("inbound message")
    //console.error("inbound message")
    var msg_type = event.data.msgType;

    if (_.has(event.data, "msg_type")) {
        msg_type = event.data.msg_type;
    }

    if (!msg_type) {
        console.error("missing 'msg_type' value")
        return
    }

    msg_type = msg_type.toUpperCase()
    if (msg_type === "RELOAD_ALL") {
        // this message is sent from CMS Tech indicating that CMS View need to completely rebuild itself
        refetchAllData()   // a refetching the data from the API will update the state and force the UI to be redrawn.
        return;
    }

    if (msg_type === "FEATURE_LOCATION_UPDATED") {
        // this message was sent down from the Attachment editing dialog
        __feature_location_updated(event.data);
        return;
    }

    if (msg_type === "ASSET_DATA") {  // this message is sent when an asset has been edited
        console.error("ui_event update asset")
        var asset_data = event.data.asset
        // console.log(asset_data);
        dispatch(ts_temp__actions.ACTION_UPDATE_ASSETS, [asset_data]);
        return;
    }

    if (msg_type === "FINDING_DATA"){
        console.error("ui_event update finding_data")
        var finding_data = event.data.finding;
        update_a_finding(finding_data);
        return;
    }
}

function update_a_finding(raw_finding_data){ // this is broken out so it can be tested in headless mode.
    dispatch(ts_temp__actions.ACTION_UPDATE_FINDINGS, [raw_finding_data]);
}

// accept and handle in-bound messages
window.addEventListener('message', __event_listener, false);
window.addEventListener('message', ts_temp__event_listener, false);

// for the ipad/phone, long touch to open debug mode
// var touchStartTime;
// var timeoutval_milliseconds = 10*1000;
// window.addEventListener('touchstart', function onFirstTouch() {
//     touchStartTime = new Date().getTime();
// }, false);
// window.addEventListener('touchend', function () {
//     var now = new Date().getTime();
//     if (touchStartTime)
//     {
//         var duration = now - touchStartTime;
//         if (duration > timeoutval_milliseconds)
//         {
//             toggleDebug();
//         }
//     }
// }, false);

function __api_createattachment_start() {
    __lock_the_screen("Add Photo", "adding photo")
}

function __api_createattachment_stop() {
    refetchAttachmentsData();
    dispatch(ACTION_SET_MENU_ATTACHMENTS_SELECTED, true);
    __unlock_the_screen();
}

function __api_deleteattachment_start() {
    __lock_the_screen("Delete Attachment", "Deleting ...")
}

function __api_deleteattachment_stop() {
    // if the state changed, and it went from true to false, then deleting attachment just ended. reload the attachments layer
    refetchAttachmentsData();
    //    dispatch(ACTION_SET_MENU_ATTACHMENTS_SELECTED, true);
    __unlock_the_screen();
}


function __lock_the_screen(title, text) {
    // AWH TODO: move this to main_ui.ts
    $('#busy_modal_title').html(title);
    $('#busy_modal_content').html(text);
    $('#busy_modal').modal({ backdrop: 'static', keyboard: false })
}

function __unlock_the_screen() {
    $('#busy_modal').modal('hide')
    $('#busy_modal_title').html("");
    $('#busy_modal_content').html("");
}
function __alert_the_user(title, text) {
    $('#alert_the_user_modal_title').html(title);
    $('#alert_the_user_modal_content').html(text);
    $('#alert_the_user_modal').modal({ backdrop: 'static', keyboard: false })
}

var ___escapeCount = 0;

// catch escape key to exit the add asset/wo state
$(document).on('keyup', function (evt) {
    if (evt.keyCode == 27) {
        ___escapeCount++;
        if (___escapeCount >= 10) {
            toggleDebug();
            ___escapeCount = 0;
        }
        var state = getImmState();
        if (state.get(KEY_STATE_ADD_ASSET)) {
            dispatch(ACTION_SET_ADD_ASSET_STATE, false)
        }
        if (state.get(KEY_STATE_CREATING_ATTACHMENT) != VALUE_CREATING_ATTACHMENT_VOID) {
            dispatch(ACTION_SET_ADD_ATTACHMENT_STATE, false)
        }
        if (state.get(KEY_STATE_ADD_WORKORDER)) {
            dispatch(ACTION_SET_ADD_WORKORDER_STATE, false)
        }
    }
    else {
        ___escapeCount = 0;
    }
});

import { proj } from '../src/ts/openlayers/ol-bridge';
ts_temp__map_initializer(map, _mapLayers, proj);

cmsViewReloadAll()




// WEBPACK FOOTER //
// ./js/cms_view_view.js